import Template from './DisplayCollectionItemView.njk';
import Marionette from "backbone.marionette";

export const DisplayCollectionItemView = Marionette.View.extend({
  template: Template,
    tagName: "a",
    className: "DisplayCollectionItemView list-group-item",

    attributes() {
        return {
            "href": "#display/" + this.model.id + "/configure"
        }
    },

    templateContext() {
        return {
            "displayName": this.model.get("name") ? this.model.get("name") : "Unnamed display"
        }
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/DisplayCollectionItemView.js